/**
 * Tarih yardımcıları.
 *
 * `new Date().toISOString().slice(0, 10)` KULLANMAYIN: toISOString UTC'ye çevirir,
 * Türkiye UTC+3 olduğu için gece 00:00–03:00 arasında DÜNÜN tarihini döndürür.
 * Form varsayılanları bu yüzden sessizce bir gün geri geliyordu (kasa hareketi,
 * mal kabul, sevkiyat, satın alma siparişi...).
 */

const iki = (n: number) => String(n).padStart(2, "0");

/** Yerel (Türkiye) tarihe göre bugün — "YYYY-MM-DD", <input type="date"> için. */
export const todayLocal = (): string => toDateInput(new Date());

/** Bir Date'i yerel tarihe göre "YYYY-MM-DD" yapar. */
export const toDateInput = (d: Date): string =>
  `${d.getFullYear()}-${iki(d.getMonth() + 1)}-${iki(d.getDate())}`;

/** Bir Date'i yerel saate göre "YYYY-MM-DDTHH:mm" yapar — <input type="datetime-local"> için. */
export const toDateTimeInput = (d: Date): string =>
  `${toDateInput(d)}T${iki(d.getHours())}:${iki(d.getMinutes())}`;

/** "YYYY-MM-DD" biçimli bir tarihe gün ekler; saat dilimi karışmaz. */
export const addDaysLocal = (isoDate: string, days: number): string => {
  const [y, m, d] = isoDate.split("-").map(Number);
  const dt = new Date(y, (m || 1) - 1, d || 1);
  dt.setDate(dt.getDate() + days);
  return toDateInput(dt);
};
